import React, { FC } from 'react';
import FormItemLabel from 'antd/es/form/FormItemLabel';
import { Input } from 'antd';
interface ICustomInput {
  label: string;
  name: string;
  value: string;
  handleChange: (name: string, value: string | boolean | number) => unknown;
  handleSaveXPath: () => unknown;
}
export const CustomTextArea: FC<ICustomInput> = ({
  label,
  name,
  value,
  handleChange,
  handleSaveXPath,
}) => {
  return (
    <div className={'CustomSwitch'}>
      <FormItemLabel prefixCls={label} label={label} htmlFor={name} />
      <Input.TextArea
        name={name}
        rows={4}
        value={value}
        onChange={(e) => handleChange(name, e.target.value)}
        placeholder={label}
        onBlur={handleSaveXPath}
      />
    </div>
  );
};
